import React from 'react';
import PropTypes from 'prop-types';

const GenericStudyDisplay = ({
  studyDescription,
  studyClass,
  weightClass,
  crosstabWeightTypes,
}) => (
  <span>
    <span className={studyClass}>{studyDescription}</span>&nbsp;
    <span className={weightClass}>
      {crosstabWeightTypes ? crosstabWeightTypes.wn : ''}
    </span>
  </span>
);

GenericStudyDisplay.propTypes = {
  studyDescription: PropTypes.string,
  studyClass: PropTypes.string,
  weightClass: PropTypes.string,
};

export default GenericStudyDisplay;
